import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
}));
